import {
  ChangeEvent,
  DragEvent,
  MouseEvent,
  useEffect,
  useRef,
  useState,
} from "react";
import { Box } from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import Button from "@mui/material/Button";
import { useFormContext } from "react-hook-form";

const Label = ({ label }: { label: string }) => <span>{label}</span>;
const NazivDokumenta = ({ naziv }: any) => <span>{naziv}</span>;

const Index = ({
  nazivPolja,
  label,
}: {
  nazivPolja: string;
  label: string;
}) => {
  const [file, setFile] = useState<File | null>(null);
  const fileRef = useRef<HTMLInputElement>(null);
  const { register, setValue } = useFormContext();

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer.files === null) return;
    setFile(e.dataTransfer.files[0]);
  };

  const dodajDokument = (e: MouseEvent<HTMLDivElement>) => {
    if (fileRef.current === null) return;
    fileRef.current.click();
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files === null) return;
    setFile(e.target.files[0]);
  };

  const ukloni = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setFile(null);

    if (fileRef.current === null) return;
    fileRef.current.value = "";
  };

  useEffect(() => {
    setValue(nazivPolja, file);
  }, [file]);

  return (
    <Box
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      className={"dragAndDrop"}
      onClick={dodajDokument}
      sx={{
        border: "1px dashed",
        borderColor: "grey.600",
        textAlign: "center",
        height: 150,
        color: "grey.600",
        fontSize: 14,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      {file && <ArticleIcon fontSize={"large"} />}
      {(file === null || file === undefined) && <Label label={label} />}
      {file !== null && file !== undefined && (
        <NazivDokumenta naziv={file.name} />
      )}
      {file !== null && file !== undefined && (
        <Button type={"button"} onClick={ukloni}>
          Ukloni
        </Button>
      )}
      <input
        {...register(nazivPolja)}
        type="file"
        hidden={true}
        onChange={handleChange}
        ref={fileRef}
      />
    </Box>
  );
};

export default Index;
